function getYouTubeEmbedCode(url) {
	const regex = /(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/watch\?v=|youtu\.be\/)([a-zA-Z0-9_-]+)/;
	const match = url.match(regex);
	if (match && match[1]) {
		return `<iframe width="560" height="315" src="https://www.youtube.com/embed/${match[1]}" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>`;
	}

	return null;
}

function getVimeoEmbedCode(url) {
	const regex = /(?:https?:\/\/)?(?:www\.)?vimeo\.com\/([0-9]+)/;
	const match = url.match(regex);
	if (match && match[1]) {
		return `<iframe src="https://player.vimeo.com/video/${match[1]}" width="640" height="360" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>`;
	}

	return null;
}

function getMassBioVideoEmbedCode(url) {
	// sample url: https://mbvision.massbio.org/Video/2cb6aa49-8a26-4dd4-9822-800c4466e683?authkey=ffa8e104-ecac-4759-bf4e-b7361f716440
	// extract the video ID from the URL
	const regex = /(?:https?:\/\/)?(?:www\.)?(mbvision\.massbio\.org\/Video\/)([a-zA-Z0-9-]+)/;
	const match = url.match(regex);
	if (match) {
		return `<iframe src="${url}" width="640" height="360" frameborder="0" allowfullscreen></iframe>`;
	}

	return null;
}

/**
 * If a valid YouTube, Vimeo, or MassBio video URL is provided, return the embed code.
 *
 * @param {?string} url
 * @returns {string|null}
 */
export function getVideoEmbedCode(url) {
	if (!url) {
		return null;
	}

	if (url.includes('youtube.com')) {
		return getYouTubeEmbedCode(url);
	}

	if (url.includes('vimeo.com')) {
		return getVimeoEmbedCode(url);
	}

	if (url.includes('mbvision.massbio.org')) {
		return getMassBioVideoEmbedCode(url);
	}

	console.error(`Unsupported video URL: ${url}`);

	return null;
}
